export default __webpack_public_path__ + "static/media/graphic-05.69078c24.png";